export default function setup() {
    $(document).ready(function () {
        function defaultRedirect() {
            const urlPath = location.pathname;
            if (urlPath === "/private-seller")
                loadPageContent("/private-seller/view-my-listed-boats");
        }

        defaultRedirect();

        function setActiveLink() {
            const urlPath = location.pathname;
            const nameElem = "a[data-url='" + urlPath + "']";
            const link = $(nameElem);
            link.addClass('active-menu-item');
        }
        setActiveLink();
        //Handle menu item clicks and load content dynamically
        $('.menu-link').on('click', function (event) {
            event.preventDefault();
            var url = $(this).data('url');
            // Remove 'active' class from all menu links
            $('.menu-link').removeClass('active-menu-item');

            // Add 'active' class to the clicked menu link
            $(this).addClass('active-menu-item');
            loadPageContent(url);
        });

        //Function to load the content into the right column
        function loadPageContent(url) {
            window.location.replace(url);
        }

        $(window).on("scroll load resize", function () {
            var w_top = $(window).scrollTop(); 
            const widht = document.documentElement.clientWidth;
            if (widht > 768) {
                if (w_top > 0) {
                    $('.left-menu').css({ 'min-height': '863px' });
                }
                else {
                    $('.left-menu').css({ 'min-height': '823px' });
                }
            }
            else {
                $('.left-menu').css({ 'min-height': '430px' });
            }
        });

        //function hideFooter() {
        //    // Get the current URL
        //    var currentUrl = window.location.href;

        //    // Check if the URL contains 'private-seller'
        //    if (currentUrl.includes('private-seller') ||
        //        currentUrl.includes('dealer')) {
        //        $("#footer").hide();
        //    }
        //}
        //hideFooter();
    });
}